
import { Loan } from '@/types';

// Mock Loans
export const loans: Loan[] = [
  {
    id: 'loan-1',
    employeeId: 'emp-1',
    amount: 5000,
    requestDate: '2023-03-15',
    status: 'approved',
    approvalDate: '2023-03-16',
    installmentAmount: 1000,
    remainingAmount: 3000,
    purpose: 'Home renovation'
  },
  {
    id: 'loan-2',
    employeeId: 'emp-2',
    amount: 3000,
    requestDate: '2023-04-01',
    status: 'pending',
    installmentAmount: 500,
    remainingAmount: 3000,
    purpose: 'Medical expenses'
  },
  {
    id: 'loan-3',
    employeeId: 'emp-3',
    amount: 2000,
    requestDate: '2023-02-10',
    status: 'paid',
    approvalDate: '2023-02-11',
    installmentAmount: 500,
    remainingAmount: 0,
    purpose: 'Education fees'
  }
];
